// Convierte los columnFilters de la tabla en params para el back
type Operadores = Record<string, "exact" | "like" | "gte" | "lte" | "ne" | "in">;

const aISO = (v: any, finDia: boolean): string | undefined => {
  const d = v?.toDate ? v.toDate() : v instanceof Date ? v : new Date(v);
  if (isNaN(d.getTime())) return undefined;
  const p = (n: number) => String(n).padStart(2, "0");
  const fecha = `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
  return finDia ? `${fecha}T23:59:59` : `${fecha}T00:00:00`;
};

// export const toFilterParams = (
//     columnFilters: { id: string; value: any }[] = []) => {
//   const out: Record<string, any> = {};
//   for (const f of columnFilters) {
//     if (f.value === '' || f.value == null) continue;
//     const esTexto =
//       typeof f.value === 'string' && !['true', 'false'].includes(f.value);
//     out[esTexto ? `${f.id}_like` : f.id] = f.value;  // texto -> like ; resto -> igualdad
//   }
//   return out;
// };

export const toFilterParams = (
  columnFilters: any = [],
  operadores: Operadores = {}
): Record<string, string> => {
  const arr = Array.isArray(columnFilters) ? columnFilters : [];
  const params: Record<string, string> = {};

  for (const { id, value } of arr) {
    if (value === undefined || value === null || value === "") continue;

    // Rango (date-range): MRT manda [min, max]
    if (Array.isArray(value)) {
      const [min, max] = value;
      if (min) params[`${id}_gte`] = aISO(min, false) ?? String(min);
      if (max) params[`${id}_lte`] = aISO(max, true) ?? String(max);
      continue;
    }

    const op = operadores[id];
    if (op) params[`${id}_${op}`] = String(value);
    else params[id] = String(value); // sin sufijo = EQ (texto -> contiene)
  }
  return params;
};